import React from "react";
import api from "../../../services/api";
import * as S from "./styles";
import TypeProduct from "../../../assets/icons/icon-spray-gray.png";
import Biologic from "../../../assets/icons/icon-Biologico-dna.svg";
import { BodyP, H6, TaglineP } from "../../../styles/stylesTypography";
import { theme } from "../../../styles/theme";
import ButtonV2 from "../../button/button_v2";
import receitaIcon from "../../../assets/icons/icon-doc-white.png";

const Items = ({ isbiologic, bgGreen, produto, onNameClick, cultura, praga, uf, ...props }) => {
  const productClassLabel = Array.isArray(produto?.nome_product_class)
    ? produto.nome_product_class.filter(Boolean).join(" / ")
    : (produto?.nome_product_class || "");

  function formatarData(dataISO) {
    const data = new Date(dataISO);
    const opcoes = { day: "2-digit", month: "short", year: "numeric" };

    return data
      .toLocaleDateString("pt-BR", opcoes)
      .toUpperCase()
      .replace(".", "");
  }

  const biologic = () => {
    if (isbiologic) {
      return (
        <S.Type bgGreen={true}>
          <img src={Biologic} alt="Imagem de produto Biológico" />

          <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={800}>
            Biológico
          </TaglineP>
        </S.Type>
      );
    }
  };

  const goToRecipe = async (id) => {
    const cultureVal = cultura && cultura !== '*' ? cultura : '';
    const pestVal = praga && praga !== '*' ? praga : '';
    const stateVal = uf && uf !== '*' ? uf : '';
    const productVal = id.agro_product_id;

    let relations = "";

    if (cultureVal && pestVal && productVal) {
      try {
        const response = await api.get(`/relacoes/${productVal}/${cultureVal}/${pestVal}`);
        if (response.data && response.data.data && response.data.data.length > 0) {
          relations = response.data.data[0].id;
        }
      } catch (error) {
        console.error("Erro ao buscar relação:", error);
      }
    }

    window.location.href = `/receitas/add/?cultures=${cultureVal}&pests=${pestVal}&products=${productVal}&aplications=&relations=${relations}&estado=${stateVal}&dosages=&numapli=&areas=&qtd=`;
  };

  const handleNameClick = (e) => {
    e.stopPropagation();
    if (onNameClick) onNameClick(produto);
  };

  const handleNameKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      if (onNameClick) onNameClick(produto);
    }
  };

  return (
    <S.Item key={props.key}>
      <div className="div-primary">
        <div className="div-primary-one">
          {/* <TaglineP color={theme.colors.gray.Cinza_7} fontWeight={600}>
            Anúncio
          </TaglineP>
  
          <TaglineP color={theme.colors.gray.Cinza_6} fontWeight={600}>
            ATUALIZADO EM {formatarData(produto.data_revisao)}
          </TaglineP> */}
        </div>

        <H6
          color={theme.colors.gray.Cinza_2}
          fontWeight={800}
          tabIndex={0}
        >
          {produto.nome_comercial}
        </H6>

        <div className="div-primary-two">
          <BodyP color={theme.colors.gray.Cinza_2} fontWeight={400}>
            {produto.fabricante}
          </BodyP>

          <TaglineP color={theme.colors.gray.Cinza_7} fontWeight={600}>
            {produto.nome_tecnico}
          </TaglineP>
        </div>
      </div>

      <div className="div-secondary">
        <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={600}>
          {produto.nome_toxicological_class}
        </TaglineP>

        <div className="types">
          <S.Type>
            <img src={TypeProduct} alt="Imagem de Tipo do produto" />

            <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={800}>
              {productClassLabel}
            </TaglineP>
          </S.Type>

          {biologic()}
        </div>

        <div className="cta-hover">
          <ButtonV2
            value="Ver detalhes"
            width="130px"
            height="40px"
            outline={true}
            icon={false}
            onClick={handleNameClick}
            color="#21262F"
          />

          <ButtonV2
            value="Emitir Receita"
            width="162px"
            height="40px"
            icon={receitaIcon}
            onClick={() => goToRecipe(produto)}
          />
        </div>
      </div>
    </S.Item>
  );
};

export default Items;